// Exports
export default {
	"AccordionItem-Root": "AccordionItem-Root_XFc8+",
	"AccordionItem-TitleAndButtonWrapper": "AccordionItem-TitleAndButtonWrapper_PZVCX",
	"AccordionItem-Title": "AccordionItem-Title_m67D6",
	"AccordionItem-DescriptionWrapper": "AccordionItem-DescriptionWrapper_Jyg5H",
	"AccordionItem-Description": "AccordionItem-Description_nBIgw",
	"opened": "opened_MEvLl",
	"AccordionItem-ShowButton": "AccordionItem-ShowButton_WBloC",
	"AccordionItem-ButtonIcon": "AccordionItem-ButtonIcon_+-koI"
};
